import { useState } from 'react';
import { supabase } from './supabaseClient';
import { useNavigate } from 'react-router-dom';
import './tailwind.css';
import logo from './logo.png'; // Importa il logo

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [showResetForm, setShowResetForm] = useState(false); // Nuovo stato per controllare quale modulo mostrare
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage(''); // Pulisci i messaggi precedenti
    const { error } = await supabase.auth.signInWithPassword({ email, password });

    if (error) {
    let displayMessage = error.message;

    // Logica di traduzione per errori specifici di Supabase Auth
    if (displayMessage === "Invalid login credentials") {
      displayMessage = "Credenziali di accesso non valide.";
    } else if (displayMessage === "Email not confirmed") {
      displayMessage = "Email non confermata. Controlla la tua casella di posta.";
    }
    // Puoi aggiungere altre traduzioni qui se ne incontri altri
    // es. else if (displayMessage === "User not found") { displayMessage = "Utente non trovato."; }

    setMessage('Errore: ' + displayMessage); // Imposta il messaggio di stato con la traduzione
    return;
  }

    const { data: userData } = await supabase.auth.getUser();
    const userId = userData?.user?.id;

    const { data: profilo, error: profiloError } = await supabase
      .from('utenti')
      .select('ruolo::text, first_login') // Seleziona anche first_login
      .eq('id', userId)
      .single();

    if (profiloError) {
      console.error('Errore nel caricamento del profilo utente:', profiloError.message);
      setMessage('Errore nel caricamento del profilo utente.');
      await supabase.auth.signOut(); // Esci per sicurezza
      return;
    }

    if (profilo) {
      // Se è il primo login, reindirizza al cambio password forzato
      if (profilo.first_login) {
        navigate('/forced-password-change');
        return;
      }

      // Reindirizza in base al ruolo se non è il primo login
      if (profilo.ruolo === 'broker') navigate('/dashboard/broker');
      else if (profilo.ruolo === 'agenzia') navigate('/dashboard/agenzia');
      else if (profilo.ruolo === 'agente') navigate('/dashboard/agente');
      else setMessage('Ruolo utente non riconosciuto');
    } else {
      setMessage('Profilo utente non trovato.');
      await supabase.auth.signOut(); // Esci per sicurezza
    }
  };

  // Funzione per mostrare il modulo di reset password
  const requestResetPassword = () => {
    setShowResetForm(true);
    setMessage(''); // Pulisci i messaggi quando si cambia modulo
  };

  // Funzione per inviare l'email di reset password
  const sendResetEmail = async (e) => {
    e.preventDefault();
    if (!email) {
      setMessage('Inserisci la tua email per il reset della password.');
      return;
    }
    setMessage('Invio link di reset password...');
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password` // URL dove l'utente resetterà la password
    });

    if (error) {
      setMessage('Errore nell\'invio del link di reset: ' + error.message);
    } else {
      setMessage('Se l\'email è registrata, riceverai un link per resettare la password.');
      // Non pulire l'email subito per permettere all'utente di vedere l'indirizzo
      // setEmail('');
    }
  };

  return (
    // Il div più esterno gestisce il background, l'altezza e il centramento
    <div className="flex items-center justify-center min-h-screen bg-gray-100 text-white font-sans"> {/* Sfondo temporaneo */}
      <header className="w-full max-w-md p-8 text-center">
        <img src={logo} alt="Europassistance" className="mb-4 mx-auto h-15" /> {/* Aggiungi il logo qui */}
        <h1 className="text-2xl md:text-2xl text-mioblu mb-2 font-semibold uppercase">
          Benvenuto nel programma di gestione adesioni
        </h1>
        <p className="text-base md:text-lg text-mioblu mb-8 opacity-80">
          Inserisci i tuoi dati per accedere alla Dashboard
        </p>

        {!showResetForm ? (
          <>
            <form onSubmit={handleLogin} className="flex flex-col w-full gap-4">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-4 py-3 border-none rounded-md text-base bg-white text-black focus:outline-none focus:border-b-2 focus:border-red-600"
              />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full px-4 py-3 border-none rounded-md text-base bg-white text-black focus:outline-none focus:border-b-2 focus:border-red-600"
              />
              <button
                type="submit"
                className="w-full px-4 py-3 text-base bg-miorosso border-none text-white font-sans transition-colors duration-300 ease-in-out tracking-wide rounded-md hover:bg-mioblu focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
              >
                Login
              </button>
            </form>

            <p
              className="text-miorosso text-sm mt-3 underline cursor-pointer hover:text-mioblu transition-colors duration-200"
              onClick={requestResetPassword}
            >
              Password dimenticata?
            </p>
          </>
        ) : (
          <>
            <form onSubmit={sendResetEmail} className="flex flex-col w-full gap-4">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-4 py-3 border-none rounded-md text-base bg-white text-black focus:outline-none focus:border-b-2 focus:border-red-600"
              />
              <button
                type="submit"
                className="w-full px-4 py-3 text-base bg-miorosso border-none text-white font-sans transition-colors duration-300 ease-in-out tracking-wide rounded-md hover:bg-mioblu focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
              >
                RIPRISTINA
              </button>
            </form>

            <p
              className="text-miorosso text-sm mt-3 underline cursor-pointer hover:text-mioblu transition-colors duration-200"
              onClick={() => setShowResetForm(false)}
            >
              Torna al Login
            </p>
          </>
        )}

       {message && (
  <p className="mt-4 text-sm text-miorosso font-bold uppercase">{message}</p>
  // Ho rimosso opacity-90 perché se vuoi sia bold e rosso, vuoi che sia ben visibile
)}
      </header>
    </div>
  );
}
